import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function FormLoadingPlaceholder({
  message = 'Loading form…'
}) {
  var _theme$typography$bod, _theme$typography$bod2, _theme$typography$bod3, _theme$typography$bod4;
  const theme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 300,
      color: theme.color['text-core-subtle'],
      fontFamily: (_theme$typography$bod = (_theme$typography$bod2 = theme.typography['body-200']) === null || _theme$typography$bod2 === void 0 ? void 0 : _theme$typography$bod2.fontFamily) !== null && _theme$typography$bod !== void 0 ? _theme$typography$bod : 'inherit',
      fontSize: (_theme$typography$bod3 = (_theme$typography$bod4 = theme.typography['body-200']) === null || _theme$typography$bod4 === void 0 ? void 0 : _theme$typography$bod4.fontSize) !== null && _theme$typography$bod3 !== void 0 ? _theme$typography$bod3 : '14px'
    },
    children: message
  });
}